import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <button className="nav-toggle" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
        

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMenu}>HOME</Link>
          <Link to="/about" className="nav-link" onClick={closeMenu}>ABOUT</Link>
          <Link to="/projects" className="nav-link" onClick={closeMenu}>PROJECTS</Link>
          <Link to="/inquiry" className="nav-link" onClick={closeMenu}>CONTACT</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;